/**
 * 节点信息生成
 * **/
const flowFormatNode = data => {
    return data.map(item => {
        return {
            id: item.act_id,
            label: { text: item.label },
            name: item.act_name,
        }
    })
}

/**
 * 流程节点关系数组生成
 * **/
const createEdges = node => {
    switch (node.isForward) {
        case '0':
            // 0表示节点是当前节点，当前节点找上下游
            let sourceEdges = node.source.map(item => {
                return { source: item, target: node.id, type: 'can-running' };
            });
            let targetEdges = node.target.map(item => {
                return { source: node.id, target: item, type: 'can-running' };
            });
            return [...sourceEdges, ...targetEdges];
        case '1':
            // 1表示下游节点，下游节点找下游
            return node.target.map(item => {
                return { source: node.id, target: item, type: 'can-running' };
            });
        case '-1':
            // -1表示上游节点，上游节点找上游
            return node.source.map(item => {
                return { source: item, target: node.id, type: 'can-running' };
            });
        default:
            return [];
    }
};
/**
 * 节点简单拖拽位置变化
 * **/
const dragNodeChangePostion = graph => {
    let node;
    let dx;
    let dy;
    graph.on('node:dragstart', ev => {
        const { item } = ev;
        const model = item.getModel();
        node = item;
        dx = model.x - ev.x;
        dy = model.y - ev.y;
    });
    graph.on('node:drag', ev => {
        node && graph.update(node, {
            x: ev.x + dx,
            y: ev.y + dy,
        });
    });
    graph.on('node:dragend', () => {
        node = undefined;
    });
}

/**
 * 生成初始化的当前所属节点
 * **/
const generateInitSelected = data => {
    return data.filter(item => {
        return item.ispassroute
    })
}

/**
 * 判断两个对象数组是否相等 【升级之后没有用的】
 * **/
const equalArray = (arr1, arr2) => {
    if (!arr1 || !arr2) return false;
    if (Object.prototype.toString.call(arr1).slice(8, -1) !== 'Array' || Object.prototype.toString.call(arr2).slice(8, -1) !== 'Array') return false;
    return JSON.stringify(arr1) === JSON.stringify(arr2)
}

/**
 * 查找上下游的节点和路径 参数data: 查找相关数据的原始数据范围
 */
const getRelated = (keyNodeId, data) => {
    let edges = [];
    let sources = [];
    let targets = [];
    let getSource = id => {
        let sourceEdges = data.edges.filter(({ target }) => target === id);
        let sourceIds = sourceEdges.map(item => item.source);
        edges.push(...sourceEdges);
        sources.push(...sourceIds);
        if (sourceIds.length > 0) {
            sourceIds.forEach(item => getSource(item));
        }
    };
    let getTargets = id => {
        let targetEdges = data.edges.filter(({ source }) => source === id);
        let targetIds = targetEdges.map(item => item.target);
        edges.push(...targetEdges);
        targets.push(...targetIds);
        if (targetIds.length > 0) {
            targetIds.forEach(item => getTargets(item));
        }
    };
    getSource(keyNodeId);
    getTargets(keyNodeId);
    edges = [...new Set(edges)];
    let nodeIds = [...new Set([...sources, keyNodeId, ...targets])]; // 用 Set 去重
    let nodes = nodeIds.map(item => {
        return data.nodes.find(ele => ele.id === item);
    });
    return {
        edges,
        nodes,
    };
};
export {
    flowFormatNode,
    createEdges,
    dragNodeChangePostion,
    generateInitSelected,
    equalArray,
    getRelated,
}